import { News } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const NEWS_DATA: News[] = [
  {
    id: 'rentree-scolaire-2026',
    title: 'Rentrée scolaire 2026 : Inscriptions ouvertes',
    excerpt: 'Les inscriptions pour la rentrée scolaire 2026-2027 sont ouvertes. Retrouvez toutes les informations pratiques et les démarches à suivre.',
    content: 'La ville de Gréasque informe les familles que les inscriptions scolaires pour l\'année 2026-2027 sont désormais ouvertes. Les parents peuvent effectuer leurs démarches en ligne via le Portail Famille ou se rendre directement en mairie aux horaires d\'ouverture. Documents nécessaires : livret de famille, justificatif de domicile de moins de 3 mois, carnet de santé de l\'enfant. Pour toute question, contactez le service scolaire au 04 42 69 86 06.',
    image: IMAGES.MAIRIE_1,
    date: '2026-03-15',
    category: 'À la une',
    featured: true,
  },
  {
    id: 'elections-municipales-2026',
    title: 'Élections municipales : Inscriptions sur les listes électorales',
    excerpt: 'Vous avez jusqu\'au 31 mars pour vous inscrire sur les listes électorales en vue des prochaines élections.',
    content: 'La commune de Gréasque rappelle aux citoyens que les inscriptions sur les listes électorales sont ouvertes jusqu\'au 31 mars 2026. Vous pouvez effectuer votre inscription en ligne sur service-public.fr ou vous rendre en mairie avec une pièce d\'identité et un justificatif de domicile. Les procurations peuvent également être établies pour les personnes absentes le jour du scrutin.',
    image: IMAGES.VILLAGE_3,
    date: '2026-03-10',
    category: 'Vie quotidienne',
  },
  {
    id: 'formation-bafa-2026',
    title: 'Formation BAFA : Session de printemps',
    excerpt: 'Une nouvelle session de formation BAFA est organisée au printemps. Inscriptions ouvertes pour les jeunes de 17 ans et plus.',
    content: 'La ville de Gréasque, en partenariat avec les Francas, organise une session de formation BAFA du 15 avril au 22 avril 2026. Cette formation s\'adresse aux jeunes de 17 ans et plus souhaitant devenir animateurs. Tarifs préférentiels pour les résidents de Gréasque. Renseignements et inscriptions auprès du service jeunesse de la mairie.',
    image: IMAGES.EVENEMENT_2,
    date: '2026-03-05',
    category: 'Culture',
  },
  {
    id: 'frelon-asiatique-2026',
    title: 'Lutte contre le frelon asiatique : Campagne de prévention',
    excerpt: 'La commune lance une campagne de sensibilisation et de lutte contre le frelon asiatique. Signalement des nids obligatoire.',
    content: 'Face à la prolifération du frelon asiatique, la ville de Gréasque met en place une campagne de prévention et de destruction des nids. Les habitants sont invités à signaler tout nid repéré via le formulaire en ligne sur le site de la mairie. Des interventions gratuites seront organisées pour la destruction des nids sur le domaine public. Pour les propriétés privées, des aides financières sont disponibles.',
    image: IMAGES.PLACE_3,
    date: '2026-02-28',
    category: 'Vie quotidienne',
  },
  {
    id: 'dechets-vegetaux-2026',
    title: 'Collecte des déchets végétaux : Nouveau calendrier',
    excerpt: 'Le nouveau calendrier de collecte des déchets végétaux et de broyage est disponible. Consultez les dates pour votre quartier.',
    content: 'La commune de Gréasque informe les habitants que le nouveau calendrier de collecte des déchets végétaux pour l\'année 2026 est disponible en mairie et sur le site internet. Le service de broyage à domicile est également reconduit sur inscription. Les dates de passage varient selon les quartiers. Pensez à sortir vos bacs la veille au soir pour une collecte optimale.',
    image: IMAGES.CULTURE_4,
    date: '2026-02-20',
    category: 'Vie quotidienne',
  },
  {
    id: 'centre-culturel-programmation',
    title: 'Centre culturel : Programmation 2026-2027',
    excerpt: 'Découvrez la nouvelle programmation du centre culturel avec spectacles, concerts et expositions pour toute la famille.',
    content: 'Le centre culturel de Gréasque dévoile sa programmation pour la saison 2026-2027. Au programme : théâtre, concerts, expositions d\'art, spectacles jeune public et conférences. Les abonnements sont disponibles dès maintenant avec des tarifs préférentiels pour les résidents. Réservations en ligne ou à l\'accueil du centre culturel. Ne manquez pas l\'inauguration de la saison le 15 septembre avec un concert gratuit en plein air.',
    image: IMAGES.VILLAGE_5,
    date: '2026-02-15',
    category: 'Culture',
  },
];